import { Link } from 'react-router-dom';
import { Sparkles } from 'lucide-react';
import { useSession } from '@/features/auth/use-session';

const DAY_MS = 24 * 60 * 60 * 1000;

/**
 * A thin strip above the app while a workspace is on its free trial, counting
 * down the days so the end of the trial is never a surprise.
 */
export function TrialBanner() {
  const { data: user } = useSession();
  const org = user?.organization;
  if (!org || org.plan !== 'TRIAL' || !org.trialEndsAt) return null;

  const daysLeft = Math.ceil((new Date(org.trialEndsAt).getTime() - Date.now()) / DAY_MS);
  const ended = daysLeft <= 0;
  const canManage = user.roles.some((role) => role.key === 'super_admin');

  return (
    <div
      className={
        ended
          ? 'flex flex-wrap items-center justify-center gap-x-3 gap-y-1 bg-destructive px-4 py-1.5 text-center text-[13px] text-destructive-foreground'
          : 'flex flex-wrap items-center justify-center gap-x-3 gap-y-1 border-b border-white/[0.06] bg-sidebar-2 px-4 py-1.5 text-center text-[13px] text-white/75'
      }
    >
      <span className="flex items-center gap-1.5">
        <Sparkles className="h-3.5 w-3.5 text-sidebar-accent" />
        {ended
          ? 'Your free trial has ended.'
          : `${daysLeft} ${daysLeft === 1 ? 'day' : 'days'} left in your free trial.`}
      </span>
      {canManage && (
        <Link to="/admin/billing" className="rounded-full bg-primary px-2.5 py-0.5 text-xs font-bold text-primary-foreground hover:bg-primary/90">
          Choose a plan
        </Link>
      )}
    </div>
  );
}
